// Angular
import { Component, ViewChild, ViewContainerRef } from '@angular/core';

// Formly
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-panel',
    templateUrl: './panel.wrapper.component.html',
    styleUrls: ['./panel.wrapper.component.scss'],
})
export class PanelWrapperComponent extends FieldWrapper {
    @ViewChild('fieldComponent', { static: true, read: ViewContainerRef }) fieldComponent: ViewContainerRef;

    isCollapsed = false;

}
